import * as DOCTOR from '../constants/doctor';


export default {
  [DOCTOR.MUTATE_LIST_DOCTOR]: (state, data) => {
    state.list = data;
  }
}


// WEBPACK FOOTER //
// ./src/store/doctor/mutations.js